import axiosActionsFactory from '../axiosHelpers';
import UrlService from '../../../services/UrlService';
import ApiService from '../../../services/ApiService';

export const AI_IMPORT_PREVIEW = axiosActionsFactory('AI_IMPORT_PREVIEW_LOAD');
export const AI_IMPORT = axiosActionsFactory('AI_IMPORT_LOAD');
export const AI_REANALYZE = axiosActionsFactory('AI_REANALYZE_LOAD');

export const aiPreviewOrders = (file, contextCompanyId, opts = {}) => async (dispatch) => {
  dispatch({ type: AI_IMPORT_PREVIEW.START });

  try {
    const formData = new FormData();
    formData.append('file', file);

    const analyzeRes = await ApiService.defaultInstance.post(
      UrlService.aiImportAnalyzeFile(),
      formData,
      {
        params: { contextCompanyId },
        headers: { 'Content-Type': 'multipart/form-data' },
      },
    );

    const previewId = analyzeRes?.data?.previewId;
    if (!previewId) {
      const fail = { type: AI_IMPORT_PREVIEW.FAIL, error: new Error('NO_PREVIEW_ID') };
      dispatch(fail);
      return fail;
    }

    const timeoutMs = 90_000;
    const started = Date.now();
    let interval = 1500;

    const poll = async () => {
      if (opts?.cancelRef?.current?.cancelled) {
        const cancelled = { type: AI_IMPORT_PREVIEW.FAIL, error: new Error('CANCELLED') };
        dispatch(cancelled);
        return cancelled;
      }
      try {
        const previewRes = await ApiService.defaultInstance.get(
          UrlService.aiImportPreview(previewId),
          { params: { contextCompanyId } },
        );

        const success = {
          type: AI_IMPORT_PREVIEW.SUCCESS,
          payload: { data: previewRes?.data },
        };
        dispatch(success);
        return success;
      } catch (err) {
        const status = err?.response?.status;
        const code = err?.response?.data?.code || err?.response?.data?.errorCode;

        if (status === 404 && code === 'AI_MONITORING_ORDER_PREVIEW_NOT_FOUND') {
          if (Date.now() - started >= timeoutMs) {
            const timeoutError = Object.assign(new Error('PREVIEW_TIMEOUT'), { code });
            const timeoutFail = { type: AI_IMPORT_PREVIEW.FAIL, error: timeoutError };
            dispatch(timeoutFail);
            return timeoutFail;
          }
          await new Promise((r) => setTimeout(r, interval));
          interval = Math.min(interval + 500, 5000);
          return poll();
        }

        const fail = { type: AI_IMPORT_PREVIEW.FAIL, error: err };
        dispatch(fail);
        return fail;
      }
    };

    return poll();
  } catch (e) {
    const fail = { type: AI_IMPORT_PREVIEW.FAIL, error: e };
    dispatch(fail);
    return fail;
  }
};

export const aiImportOrders = (orders, contextCompanyId) => (
  (dispatch) => dispatch({
    type: AI_IMPORT.START,
    payload: {
      request: {
        url: UrlService.aiImportImport(),
        method: 'post',
        data: { orders },
        params: { contextCompanyId },
        headers: {
          'Content-Type': 'application/json',
        },
      },
    },
  })
);

export const aiReanalyzeOrders = (orders, contextCompanyId) => (
  (dispatch) => dispatch({
    type: AI_REANALYZE.START,
    payload: {
      request: {
        url: UrlService.aiImportAnalyze(),
        method: 'post',
        data: { orders },
        params: { contextCompanyId },
        headers: {
          'Content-Type': 'application/json',
        },
      },
    },
  })
);
